// extracted by mini-css-extract-plugin
export default {"container":"GM-z","modal":"HM-z","dimensions":"IM-z","brandName":"JM-z","productName":"KM-z","labelValue":"LM-z","recipientEmail":"MM-z","recommendedFit":"NM-z","hiddenField":"OM-z"};